import script from "./inputImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./inputImage.vue?vue&type=script&setup=true&lang=ts"

import "./inputImage.vue?vue&type=style&index=0&id=7b807554&lang=css"

const __exports__ = script;

export default __exports__